import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "./pages/Home.tsx";
import { BookingRedirect } from "./components/BookingLink.tsx";
import { BookingDetail } from "./pages/BookingDetail.tsx";
import { Consultation } from "./pages/Consultation.tsx";
import { Admin } from "./pages/Admin.tsx";
import { NotFound } from "./pages/NotFound.tsx";

/**
 * Restore the top of the page on navigation, except when following an anchor
 * into the one-pager - that should scroll to the section, not the top.
 */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);

  return null;
}

export function App() {
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<BookingRedirect />} />
        <Route path="/booking/:reference" element={<BookingDetail />} />
        <Route path="/consultation/:reference" element={<Consultation />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
